import { render, staticRenderFns } from "./AccountValidationSummary.vue?vue&type=template&id=8445d4c8&"
import script from "./AccountValidationSummary.vue?vue&type=script&lang=ts&"
export * from "./AccountValidationSummary.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports